
export const levelComplexityConstant = {
    high: { label: "Alto", value: 'high', color: 'green' },
    average: { label: "Médio", value: 'average', color: 'orange' },
    medium: { label: "Médio", value: 'average', color: 'orange' },
    low: { label: "Baixo", value: 'low', color: 'red' }
};
export default levelComplexityConstant;